import React from 'react';
import { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Profile from '../Pages/Profile';
import About from '../Pages/About';
import Contact from '../Pages/Contact';
import Footer from '../Components/Footer';
import Work from '../Pages/Work';
import Certificates from '../Pages/Certificates';

function App() {

  useEffect(() => {
    const sectionId = window.location.hash.slice(1);
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div className="bg-[#242424] overflow-x-hidden">
      <div className=''>
      <Navbar />
      </div>
      <div id="home" className='container'>
        <Profile/>
      </div>
      <div id="about">
       <About/>
      </div>
      <div id="work">
        <Work/>
      </div>
       <div id="certificates">
       <Certificates/>
      </div>
      <div id="contact">
        <Contact/>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  );
}

export default App;


